import("pixi.js");
declare global {
    /* eslint-disable no-unused-vars */
    interface Window {
        PIXI: any;
    }
}
import * as PIXI from "pixi.js";

/* eslint-disable no-undef */
window.PIXI = PIXI;
require("pixi-spine");
require("pixi-particles");

import { gsap } from "gsap";
import { CustomEase } from "gsap/dist/CustomEase";
import { CustomWiggle } from "gsap/dist/CustomWiggle";
import { PixiPlugin } from "gsap/dist/PixiPlugin";

PixiPlugin.registerPIXI(PIXI);
gsap.registerPlugin(CustomEase, CustomWiggle, PixiPlugin);

import { NolimitSlotAudio } from "@nolimitcity/slot-audio/bin/NolimitSlotAudio";
import { SlotKeypad } from "@nolimitcity/slot-keypad/bin/SlotKeypad";
import { NolimitLauncher } from "@nolimitcity/slot-launcher/bin/NolimitLauncher";
import { NolimitGameIntroPlugin } from "@nolimitcity/slot-launcher/bin/plugins/concreteplugins/NolimitGameIntroPlugin";
import { LogLevel } from "@nolimitcity/slot-launcher/bin/utils/Logger";
import { Apocalypse } from "./game/Apocalypse";
import { NolimitPromotionPlugin } from "@nolimitcity/promo-panel/bin/NolimitPromotionPlugin";
import { ApocalypseIntroConfig } from "./game/config/ApocalypseIntroConfig";
import { ApocalypsePromoPanelConfig } from "./game/config/ApocalypsePromoPanelConfig";

// import {BrickSnake2000PromoPanelConfig} from "./game/config/BrickSnake2000PromoPanelConfig"; 

declare global {
    interface Window {
        NolimitLauncher: NolimitLauncher;
    }
}

window.NolimitLauncher = NolimitLauncher.instance;
NolimitLauncher.instance.settings.log = LogLevel.DEV;
NolimitLauncher.instance.launch([
    new Apocalypse(),
    new SlotKeypad(),
    new NolimitGameIntroPlugin(new ApocalypseIntroConfig()),
    new NolimitSlotAudio(),
    new NolimitPromotionPlugin(new ApocalypsePromoPanelConfig()),
]);
